import {
    enrichirMenu,
    ouvrirMenuAuClic,
    ouvrirSousMenuAuClic,
    retourMenuAuClic
} from "./effets/menu";
import { animerRetourHautDePage } from "./effets/retourHautDePage";

document.addEventListener("DOMContentLoaded", () => {
    animerRetourHautDePage(".ancre-header");

    let animEnCours = false;
    enrichirMenu(".menuSite li ul");
    ouvrirMenuAuClic(".menuSite-bouton");
    animEnCours = ouvrirSousMenuAuClic(
        ".menuSite-interne .lienMenu",
        992,
        animEnCours
    );
    retourMenuAuClic(animEnCours);
});